import React, { useState } from "react";

function ViewCase({ showModal, setShowModal, selectedCase }) {
  const [open, setOpen] = useState(showModal);

  const closeModal = () => {
    setOpen(false);
    setShowModal(false);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-2xl">
      <div className="bg-white rounded-2xl shadow-lg w-[1050px] h-[650px]">
        <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-teal-950 to-teal-500 py-2 text-white rounded-t-2xl">
          View Details
        </h3>
        <div className="flex-1 p-8 overflow-y-auto scrollbar-hidden w-[1050px] h-[530px]">
          <form className="bg-white">
            <div className="w-full flex gap-2 items-center">
              {/* <label className="block mb-1 mt-2 font-bold">Case Type</label> */}
              {selectedCase?.caseType && (
                <span className="inline-block bg-gray-600 text-white text-sm font-semibold px-4 py-2 rounded-full">
                  {selectedCase.caseType} - {selectedCase.caseOpinon}
                </span>
              )}
            </div>
            <h1 className="bg-teal-200 border border-gray-900 flex justify-center text-xl font-semibold mb-2 py-1 mt-2">
              Pateint's Details
            </h1>
            <div className="flex gap-2 ">
              <div className="w-full">
                <label className="block mb-1 mt-2">Owne'r Surname</label>
                <input
                  type="text"
                  name="companyName"
                  className="border border-gray-800 p-2 w-full"
                  value={selectedCase?.surName}
                  disabled
                />
              </div>

              <div className="w-full">
                <label className="block mb-1 mt-2">Pateint Name</label>
                <input
                  type="text"
                  name="companyName"
                  className="border border-gray-800 p-2 w-full"
                  value={selectedCase?.patientName}
                  disabled
                />
              </div>
            </div>

            <div className="flex gap-2">
              <div className="w-full">
                <label className="block mb-1 mt-2">Breed</label>
                <input
                  type="text"
                  name="companyName"
                  className="border border-gray-800 p-2 w-full"
                  value={selectedCase?.patientBreed}
                  disabled
                />
              </div>

              <div className="w-full">
                <label className="block mb-1 mt-2">Age</label>
                <input
                  type="text"
                  name="companyName"
                  className="border border-gray-800 p-2 w-full"
                  value={selectedCase?.patientAge}
                  disabled
                />
              </div>

              <div className="w-full">
                <label className="block mb-1 mt-2">Gender</label>
                <input
                  type="text"
                  name="companyName"
                  className="border border-gray-800 p-2 w-full"
                  value={selectedCase?.patientGender}
                  disabled
                />
              </div>
            </div>

              {selectedCase?.caseImages?.length > 0 ? (
                <>
                <label className="block mb-1 mt-2">Patient Case Files</label>
            <div className="flex gap-2 mt-2 flex-wrap">
              {selectedCase?.caseImages?.map((file, index) => {
                const fileUrl = file?.caseImage?.toLowerCase();

                if (!fileUrl) return null; // Handle empty file cases

                if (
                  fileUrl.endsWith(".mp4") ||
                  fileUrl.endsWith(".mov") || // common iPhone video
                  fileUrl.endsWith(".m4v") || // Apple video format
                  fileUrl.endsWith(".avi") ||
                  fileUrl.endsWith(".webm")
                ) {
                  return (
                    <video
                      key={index}
                      controls
                      className="w-32 h-32 object-cover rounded-md border-2 border-gray-300"
                    >
                      <source src={file.caseImage} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  );
                } else if (
                  fileUrl.endsWith(".jpg") ||
                  fileUrl.endsWith(".jpeg") ||
                  fileUrl.endsWith(".png") ||
                  fileUrl.endsWith(".gif") ||
                  fileUrl.endsWith(".heic") || // iPhone image format
                  fileUrl.endsWith(".heif") || // another variation
                  fileUrl.endsWith(".webp")
                ) {
                  return (
                    <img
                      key={index}
                      src={file.caseImage}
                      alt={`media-${index}`}
                      className="w-32 h-32 object-cover rounded-md border-2 border-gray-300"
                    />
                  );
                } else if (
                  fileUrl.endsWith(".pdf") ||
                  fileUrl.endsWith(".doc") ||
                  fileUrl.endsWith(".docx")
                ) {
                  return (
                    <a
                      key={index}
                      href={file.caseImage}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center p-2 bg-gray-100 border border-gray-300 rounded-md w-32 h-10 justify-center text-blue-600 font-bold text-sm"
                    >
                      {fileUrl.endsWith(".pdf")
                        ? "📄 View PDF"
                        : "📝 View Document"}
                    </a>
                  );
                } else {
                  return (
                    <p key={index} className="text-gray-600 text-sm">
                      Unknown file type
                    </p>
                  );
                }
              })}
            </div>
            </>
              ) : (
                <div>

                </div>
              )}
            

            {selectedCase?.caseLinks.length > 0 ? (
              <div>
                <label className="block mb-1 mt-4">File Links</label>
                <div className="mt-1 space-y-2">
                  {selectedCase?.caseLinks.map((link, index) => (
                    <div key={index}>
                      <a
                        href={link.linkUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline break-all font-bold"
                      >
                        {link?.linkUrl}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div>
                
              </div>
            )}

            <h1 className="bg-teal-200 border border-gray-900 flex justify-center text-xl font-semibold mb-2 py-1 mt-3">
              Case Summary
            </h1>

            <div className="flex gap-2 ">
              <div className="w-full">
                <label className="block mb-1 mt-2">Condition</label>
                <input
                  type="text"
                  name="companyName"
                  className="border border-gray-800 p-2 w-full"
                  value={
                    selectedCase?.urgent === "Yes" ? "Urgent" : "Not Urgent"
                  }
                  disabled
                />
              </div>

              
              {/* <div className="w-full">
                <label className="block mb-1 mt-2">Clinical Findings</label>
                <input
                  type="text"
                  name="companyName"
                  className="border border-gray-800 p-2 w-full"
                  value={selectedCase?.clinicalSign}
                  disabled
                />
              </div> */}
            </div>
            <div className="w-full">
                <label className="block mb-1 mt-2">Treatment To Date</label>
                <textarea
                rows={3}
                  type="text"
                  name="companyName"
                  className="border border-gray-800 p-2 w-full"
                  value={selectedCase?.treatmentToDate}
                  disabled
                />
              </div>

            <div className="flex gap-2 ">
              {/* <div className="w-full">
                <label className="block mb-1 mt-2">
                  Differential Diagnosis
                </label>
                <input
                  type="text"
                  name="companyName"
                  className="border border-gray-800 p-2 w-full"
                  value={selectedCase?.diagnosis}
                  disabled
                />
              </div> */}
            </div>

            <div className="w-full">
              <label className="block mb-1 mt-2">History</label>
              <textarea
                rows={3}
                type="text"
                name="companyName"
                className="border border-gray-800 p-2 w-full"
                value={selectedCase?.history}
                disabled
              />
            </div>

            {/* <div className="w-full">
              <label className="block mb-1 mt-2">Questions</label>
              <textarea
                rows={3}
                type="text"
                name="companyName"
                className="border border-gray-800 p-2 w-full"
                value={selectedCase?.questions}
                disabled
              />
            </div> */}

            {selectedCase?.caseType === "Request Referral" && (
              <>
                <div className="flex gap-2 ">
                  <div className="w-full">
                    <label className="block mb-1 mt-2">
                      How should we proceed ?
                    </label>
                    <textarea
                      rows={2}
                      type="text"
                      name="companyName"
                      className="border border-gray-800 p-2 w-full"
                      value={selectedCase?.howToProceed}
                      disabled
                    />
                  </div>

                  <div className="w-full">
                    <label className="block mb-1 mt-2">Contact Details</label>
                    <textarea
                      rows={2}
                      type="text"
                      name="companyName"
                      className="border border-gray-800 p-2 w-full"
                      value={selectedCase?.contactDetails}
                      disabled
                    />
                  </div>
                </div>

                <div className="w-full">
                  <label className="block mb-1 mt-2">Case Clinic</label>
                  <input
                    type="text"
                    name="companyName"
                    className="border border-gray-800 p-2 w-full"
                    value={selectedCase?.caseClinic}
                    disabled
                  />
                </div>
              </>
            )}
          </form>
        </div>

        <div className="flex justify-end border-t p-4">
          <button
            onClick={closeModal}
            className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewCase;
